import { SVGProps } from "react";

const PKACane = (props: SVGProps<SVGSVGElement>) => <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M19.5576 44.7684C19.5576 44.7684 32.468 20.4873 33.6417 18.28C34.8154 16.0726 37.4535 8.98102 30.3899 5.22524C23.3263 1.46947 19.1571 7.18063 17.7486 9.82948" stroke="black" strokeWidth={4} strokeLinecap="round" strokeLinejoin="round" /></svg>;

export { PKACane };